"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
//var $ = require("jquery");

var template = require("../templates/modal-template.html");

/**
 * 
 * ModalView : boite de dialog bloquante, occupe tout l'espace
 * inspiré de https://tympanus.net/Development/ModalWindowEffects/
 * Trigger:
 *     - abort
 *
 */
module.exports = Backbone.View.extend({

    template: _.template(template), // compile template
    message: null,
    title: null,
    className: "rbn-modal",
    view:null,
    effect:"slide-in-bottom", // fade-in-scale, slide-in-right, slide-in-bottom, fade-in (without blured 3d)

    events: {
        "click >.rbn-modal-overlay": "onOverlayClicked",
    },

    initialize: function(options) {
        var T=this;
        _.extend(T, options);
    },

    render: function() {
        var T = this,
            context = {
                title:T.title,
                message: T.message,
                effect:T.effect
            };
        T.$el.html(T.template(context));
        if(T.view){
            T.assign(T.view,".rbn-modal-body");
        }
        return T;
    },

    onOverlayClicked:function(){
        this.hide();
        this.trigger("abort");
    },

    show: function() {
        this.$el.addClass("rbn-modal-show");
    },

    hide: function() {
        this.$el.removeClass("rbn-modal-show");
    },

    close: function() {
        var T = this;

        if(T.view){
            T.view.close();
            T.view=null;
        }

        T.undelegateEvents();
        T.stopListening();
    }

});


//////////////////
// WEBPACK FOOTER
// ./src/views/modal-view.js
// module id = 57
// module chunks = 0